import React from "react";
import { useSelector } from "react-redux";
import { myCustomTheme } from "../../Theme";
import { useNavigate } from "react-router-dom";
import "../../Style/HeroSection.css";
import logo from "../../Assets/3d.png";

const HeroSection = () => {
  const heroData = useSelector((state) => state.hero);
  const navigate = useNavigate();
  const theme = myCustomTheme;

  return (
    <>
      {heroData.map((item, index) => (
        <section
          className="hero-section"
          key={index}
          style={{
            background:
              "linear-gradient(125deg, #001438, #bdc0c978)",
          }}
        >
          {/* Container Fluid */}
          <div className="container-fluid">
            {/* 1440px Container */}
            <div className="container-hero">

              <div className="hero-left">
                <span
                  className="hero-tag"
                  style={{
                    color: "#fff",
                    fontFamily: theme.typography.text_font,
                  }}
                >
                  3D PRINTING INDIA
                </span>

                <h1
                  style={{
                    color: "#cfefff",
                    fontFamily: theme.typography.heading_font,
                  }}
                >
                  {item.title}
                </h1>

                <h3
                  style={{
                    color: "#000000",
                    fontFamily: theme.typography.heading_font,
                  }}
                >
                  {item.subtitle}
                </h3>

                <p
                  style={{
                    color: "#c9c9c9",
                    fontFamily: theme.typography.text_font,
                  }}
                >
                  {item.description}
                </p>

                <button
                  onClick={() => navigate("/product")}
                  style={{
                    background: "#fff",
                    color: theme.colors.heading,
                    border: "1px solid transparent",
                    boxShadow: theme.shadows.hard,
                    cursor: "pointer",
                  }}
                >
                  {item.buttonText}
                </button>
              </div>

              <div className="hero-right">
                <div
                  className="circle"
                  style={{
                    background: `radial-gradient(circle,
                    ${theme.colors.bg_primary},
                    transparent 70%)`,
                  }}
                ></div>

                <div className="printer-3d">
                  <div className="cube">
                    <div
                      className="front"
                      style={{
                        borderColor: theme.colors.high_light,
                        background: "#ffffff21",
                      }}
                    >
                      <img src={logo} alt="3D Printer" />
                    </div>

                    <div
                      className="back"
                      style={{
                        borderColor: theme.colors.high_light,
                        background: "#ffffff21",
                      }}
                    >
                      <img src={logo} alt="3D Printer" />
                    </div>

                    <div
                      className="left"
                      style={{
                        borderColor: theme.colors.high_light,
                        background: "#ffffff21",
                      }}
                    >
                      <img src={logo} alt="3D Printer" />
                    </div>

                    <div
                      className="right"
                      style={{
                        borderColor: theme.colors.high_light,
                        background: "#ffffff21",
                      }}
                    >
                      <img src={logo} alt="3D Printer" />
                    </div>

                    <div
                      className="top"
                      style={{
                        borderColor: theme.colors.high_light,
                        background: "#ffffff21",
                      }}
                    >
                      <img src={logo} alt="3D Printer" />
                    </div>

                    <div
                      className="bottom"
                      style={{
                        borderColor: theme.colors.high_light,
                        background: "#ffffff21",
                      }}
                    >
                      <img src={logo} alt="3D Printer" />
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>
      ))}
    </>
  );
};

export default HeroSection;